import Tone from 'tone';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Effects from 'effects/Effects.js';
import {AbstractAudioParamParameter} from 'parameters/AbstractAudioParamParameter.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';

class PitchShift extends Effects.Effect {
    constructor(sequencerEngine) {
        super("Pitch Shift", () => new Tone.PitchShift(0), sequencerEngine);
        this.pitchParameter = new AbstractParameter(
            'Pitch', this.effectNode,
            (o, x) => {
                o.pitch = x;
            },
            {
                min: -24,
                max: 24,
                unit: '',
                defaultValue: 12
            });
        this.registerParameter(this.pitchParameter);

        this.windowSizeParameter = new AbstractAudioParamParameter(
            'Window Size', this.effectNode, (o, x) => o.windowSize = x, {
                min: 0.03,
                max: 0.1,
                unit: '',
                defaultValue: 0.03
            });
        this.registerParameter(this.windowSizeParameter);
        this.updateInitialValues();
    }

    dispose() {
        this.effectNode.dispose();
    }

    getJson() {
        let json = super.getJson();
        json.pitch  = this.pitchParameter.get(true);
        json.windowSize = this.windowSizeParameter.get(true);
        json.enabled = this.enabledParameter.get(true);
        json.wet = this.effectNode.wet.value;
        json.name = this.name;

        json = this.saveParameterToJson(json, 'pitchParameter', this.pitchParameter);
        json = this.saveParameterToJson(json, 'windowSizeParameter', this.pitchParameter);
        return json;
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);
        bulkUpdate(this.pitchParameter, json.pitch, bulk);
        bulkUpdate(this.windowSizeParameter, json.windowSize, bulk);
        if (json.enabled) {
            this.enable(true);
        }
        this.setValue(json.value);

        return {
            ... bulk,
            ... this.loadParameterFromJson(json, 'pitchParameter', this.pitchParameter, isCopy),
            ... this.loadParameterFromJson(json, 'windowSizeParameter', this.pitchParameter, isCopy)
        };
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new PitchShift(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default PitchShift;
